import { Typography } from "@mui/material";
import React from "react";
import ProfileDataCard from "./ProfileDataCard";

interface TimeInvestmentProps {
  timeInvestment: string | null;
}

/**
 * This component displays the hobbies of an applicant.
 * @param hobbies The hobbies of an applicant
 * @returns The hobbies of an applicant.
 */
const TimeInvestment = ({ timeInvestment }: TimeInvestmentProps) => {
  return (
    <ProfileDataCard title="Zeit">
      <Typography>{timeInvestment}</Typography>
    </ProfileDataCard>
  );
};

export default TimeInvestment;
